import React, { memo } from 'react';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/typographyStyle';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ILinkProps {
	children: React.ReactElement | React.ReactElement[] | string[] | string;
	to: string;
	linkProps?: object;
	type?: types.theme.fonts;
	color?: types.theme.fontColor;
	download?: boolean;
	target?: '_blank' | '_self';
	props?: object;
	isNewDashboardEnabled?: boolean;
}

const CustomLink = ({
	children,
	color = 'brand',
	to,
	type = 'caption',
	download,
	target = '_self',
	isNewDashboardEnabled = false,
	linkProps,
	props,
}: ILinkProps) => {
	const classes = useStyles({ isNewDashboardEnabled });
	const linkClasses = classNames({
		[classes[type]]: true,
		[classes[color]]: true,
		underline: true,
	});
	return (
		/** added to show aamali+services, in case of micro bundle when the route changes
		 * accountCategory is used as an identifier for microbundle
		Props has teh accountCategory which is being passed in state and is extracted in the Details component
		*/
		<Link
			to={{
				pathname: to,
				state: {
					...props,
				},
			}}
			className={linkClasses}
			download={download}
			target={target}
			{...linkProps}
		>
			{children}
		</Link>
	);
};

export default memo(CustomLink);
